export function regNrMaskFilter(value) {
  let mask = [
    /\d/,
    /(\d|\/)/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ]
  const numbers = value.replace(/[^(0-9|\/)]/g, '')
  if (numbers.length >= 2 && numbers.charAt(1) !== '/') {
    mask[2] = '/'
  }
  return mask
}
